import React from 'react';
import Styles from './LpBanner.module.less';
import { classes } from '../../../lib';

export type LpBannerProps = {
    linkProps: Partial<React.AnchorHTMLAttributes<HTMLElement>>;
    desktop: React.ReactNode;
    mobile?: React.ReactNode;
};

export const LpBanner = ({
    linkProps,
    desktop,
    mobile,
}: LpBannerProps): JSX.Element => {
    return (
        <a
            className={classes(
                'horizontal stretch-stretch lp-section',
                Styles.container
            )}
            {...linkProps}>
            <div className={classes('m-hidden flex', Styles.img)}>
                {desktop}
            </div>
            <div className={classes('td-hidden flex', Styles.img)}>
                {mobile ?? desktop}
            </div>
        </a>
    );
};
